module.exports = __webpack_public_path__ + "img/header-5.1e463652.png";